import { INVITE_INFO, INVITE_RECORDS, INVITE_DETAIL_RECORDS } from "store/ActionTypes"
import { Action, InviteInfo, InviteRecords, InviteDetailRecords } from "types/interface"

export interface InviteState {
  [INVITE_INFO]: InviteInfo | null,
  [INVITE_RECORDS]: InviteRecords | null,
  [INVITE_DETAIL_RECORDS]: InviteDetailRecords | null,
}

const defaultState: InviteState = {
  [INVITE_INFO]: null,
  [INVITE_RECORDS]: null,
  [INVITE_DETAIL_RECORDS]: null,
}

export default (state = defaultState, action: Action) => {
  const {type, value} = action
  const old_value = state[type]

  if (old_value !== undefined) {
    return {
      ...state,
      [type]: value
    }
  }
  return state
}
